export const calculateViewportUnits = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

export const calculateHeaderSize = () => {
    const header = document.querySelector('.l-header')

    if (!header) {
        return
    }

    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`)
}
